import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { ReduxState } from '../../../types/app';

export const getHomeMessageId = (homeIndex: number, key: string) =>
  `home.${homeIndex}.${key}`;

export const useHomeMessageId = () => {
  const homeIndex = useSelector(
    (state: ReduxState) => state.Data.config?.home ?? 0
  );

  return useCallback(
    (key: string) => getHomeMessageId(homeIndex, key),
    [homeIndex]
  );
};
